import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// Trust / recency / data-health cues. These live in the margins — a quiet trust chip,
// an "as of" line, a small admin-only health badge. Never alarming.

// Per-source credibility multiplier (~0.80..1.20, 1.0 neutral). Falls back to neutral.
export function useSourceCredibility(sourceId: string | null | undefined) {
  return useQuery({
    queryKey: ["research_source_credibility_factor", sourceId],
    enabled: !!sourceId,
    staleTime: 30 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("research_source_credibility_factor", {
        _source_id: sourceId as string,
      });
      if (error) throw error;
      return typeof data === "number" ? data : null;
    },
  });
}

export interface ConnectorHealthRow {
  connector: string;
  signal: string;
  severity: string | null;
  detail: string | null;
}

// Admin-only, read-only diagnostics for the quiet "data health" badge.
// NEVER call research_connector_freshness (service-role) or _sentinel_run (write) here.
export function useConnectorHealth(enabled: boolean) {
  return useQuery({
    queryKey: ["research_connector_health_scan"],
    enabled,
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("research_connector_health_scan");
      if (error) throw error;
      return ((data as unknown as ConnectorHealthRow[]) ?? []).filter(Boolean);
    },
  });
}
